import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MimetypeService {

  mimeTypeList: any[] = [
    { ext: 'pdf', type: 'application/pdf; charset=utf-8' },
    { ext: 'docx', type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document; charset=utf-8' },
    { ext: 'doc', type: 'application/msword; charset=utf-8' },
    { ext: 'xlsx', type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8' },
    { ext: 'xls', type: 'application/vnd.ms-excel; charset=utf-8' },
    { ext: 'jpg', type: 'image/jpeg; charset=utf-8' },
    { ext: 'png', type: 'image/png; charset=utf-8' },
    { ext: 'gif', type: 'image/gif; charset=utf-8' },
    { ext: 'bmp', type: 'image/bmp; charset=utf-8' },
    { ext: 'zip', type: 'application/zip; charset=utf-8' },
    { ext: 'rar', type: 'application/x-rar-compressed; charset=utf-8' }
  ];

  constructor() { }

  public getMimeType = (ext: string) => {
    let index = this.mimeTypeList.findIndex(x => x.ext === ext);
    if (index === -1) 
      return "application/" + ext + " charset=utf-8";
   return this.mimeTypeList[index].type;
  }
}
